import { ratingTypes } from 'shared/constants/ratingTypes';

export const SEARCH_START = 'SEARCH_START';

export const SEARCH_ENTITIES = 'SEARCH_ENTITIES';
export const SEARCH_ENTITIES_SUCCESS = `${SEARCH_ENTITIES}_SUCCESS`;
export const SEARCH_ENTITIES_ERROR = `${SEARCH_ENTITIES}_ERROR`;
export const SEARCH_ENTITIES_SWITCH_SCENARIO = `${SEARCH_ENTITIES}_SWITCH_SCENARIO`;

export const SEARCH_INSTRUMENTS = 'SEARCH_INSTRUMENTS';
export const SEARCH_INSTRUMENTS_SUCCESS = `${SEARCH_INSTRUMENTS}_SUCCESS`;
export const SEARCH_INSTRUMENTS_ERROR = `${SEARCH_INSTRUMENTS}_ERROR`;

export const SEARCH_RATING_NEWS = 'SEARCH_RATING_NEWS';
export const SEARCH_RATING_NEWS_SUCCESS = `${SEARCH_RATING_NEWS}_SUCCESS`;
export const SEARCH_RATING_NEWS_ERROR = `${SEARCH_RATING_NEWS}_ERROR`;

export const SEARCH_RESEARCH = 'SEARCH_RESEARCH';
export const SEARCH_RESEARCH_SUCCESS = `${SEARCH_RESEARCH}_SUCCESS`;
export const SEARCH_RESEARCH_ERROR = `${SEARCH_RESEARCH}_ERROR`;

export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS';

export const searchStartAction = {
  type: SEARCH_START,
};

export const switchScenarioAction = ({ scenario }) => ({
  type: SEARCH_ENTITIES_SWITCH_SCENARIO,
  payload: {
    scenario,
  },
});

export const searchEntitiesAction = ({
  query,
  page,
  limit,
  sort,
  filter,
  ratingType = ratingTypes.CREDIT_RATING,
  userId,
}) => ({
  type: SEARCH_ENTITIES,
  payload: {
    query,
    page,
    limit,
    sort,
    filter,
    ratingType,
    userId,
  },
});

export const searchInstrumentsAction = ({ query, page, limit, sort, filter }) => ({
  type: SEARCH_INSTRUMENTS,
  payload: {
    query,
    page,
    limit,
    sort,
    filter,
  },
});

export const searchRatingNewsAction = ({ query, filters, page, limit }) => ({
  type: SEARCH_RATING_NEWS,
  payload: {
    query,
    filters,
    type: 'RATING_NEWS',
    page,
    limit,
  },
});

export const searchResearchAction = ({ query, filters, page, limit }) => ({
  type: SEARCH_RESEARCH,
  payload: {
    query,
    filters,
    type: 'RESEARCH',
    page,
    limit,
  },
});

export const setSearchFiltersAction = (payload) => ({
  type: SET_SEARCH_FILTERS,
  payload,
});
